import DelayedComponent from './delayed-components'

export default class DelayedUserProfileOrListView extends DelayedComponent<any> {
  async getComponent() {
    const ComponentModule = await import(/* webpackChunkName: "UserProfileOrListView" */ "components/user-profile-or-list-view")
    return ComponentModule.default
  }
}